function traverse(options, callback) {
  const rootNode = {
    text: '',
    value: 'root',
    children: options,
  };

  function goThrough(node) {
    if (!callback(node)) return;

    if (node.children) {
      node.children.forEach((child) => {
        goThrough(child);
      });
    }
  }

  goThrough(rootNode);
}

// Check if at least one option is checked on the last level
export function someChildrenChecked(options, checked) {
  let result = false;

  traverse(options, (node) => {
    if (node.children) {
      for (let i = 0; i < node.children.length; i++) {
        // Last level children
        if (!node.children[i].children) {
          if (checked.includes(node.children[i].value)) {
            result = true;
            return false;
          }
        }
      }
    }

    return true;
  });

  return result;
}

// Check if all options is checked on the last level
export function everyChildrenChecked(options, checked) {
  let result = true;

  traverse(options, (node) => {
    if (node.children) {
      for (let i = 0; i < node.children.length; i++) {
        // Last level children
        if (!node.children[i].children) {
          if (!checked.includes(node.children[i].value)) {
            result = false;
            return false;
          }
        }
      }
    }

    return true;
  });

  return result;
}

// Handle selection on any level, return selected options for the last level
export function getSelectedOptions(checked, value, children, selected) {
  if (!children) {
    return checked ? [...selected, value] : selected.filter(item => item !== value);
  }

  const lastLevelChildren = [];
  traverse(children, (node) => {
    if (node.children) {
      for (let i = 0; i < node.children.length; i++) {
        // Last level children
        if (!node.children[i].children) {
          lastLevelChildren.push(node.children[i].value);
        }
      }
    }

    return true;
  });

  return checked
    ? [...selected, ...lastLevelChildren]
    : selected.filter(item => !lastLevelChildren.includes(item));
}

// Handle search matches with node text at any level
function hasMatchAtNode(node, searchQuery = '') {
  if (!node.children || !node.children.length) return false;

  const searchIncludes = text => text.toLowerCase().includes(searchQuery.toLowerCase());

  if (searchIncludes(node.text)) return true;

  let result = false;

  traverse(node.children, (child) => {
    if (searchIncludes(child.text)) result = true;

    return !result;
  });

  return result;
}

export function getSearchMatches(options, searchQuery) {
  if (!searchQuery.length) return [];

  const matchesOptions = [];

  traverse(options, (node) => {
    if (hasMatchAtNode(node, searchQuery)) {
      matchesOptions.push(node.value);
    }

    return true;
  });

  return matchesOptions;
}


/*
 * Transform options to collection of last level options by nodes
 * optionsExample = [
 *  {value: "10", text: "Energy", children: Array(1)},
 *  {value: "15", text: "Materials", children: Array(1)},
 * ]
 * retrunExample = [
 *  ['10_Energy', Array(7)],
 *  ['1010_Energy', Array(7)],
 *  ...
 *  ['15_Materials', Array(17)]....
 * ]
 */

function getNodeLastLevelOptions(children, value) {
  if (!children) return [value];

  const lastLevelChildren = [];

  traverse(children, (node) => {
    if (node.children) {
      for (let i = 0; i < node.children.length; i++) {
        // Last level children
        if (!node.children[i].children) {
          lastLevelChildren.push(node.children[i].value);
        }
      }
    }

    return true;
  });

  return lastLevelChildren;
}

export function collectionLastLevelOptionsByNodes(options) {
  const result = [];

  traverse(options, (node) => {
    if (node.children) {
      for (let i = 0; i < node.children.length; i++) {
        const { value, text, children } = node.children[i];
        result.push([`${value}_${text}`, getNodeLastLevelOptions(children, value)]);
      }
    }
    return true;
  });

  return result;
}
